import { stringToTitleCase } from '../Appointment/AppointmentHelpers';
import { getPhoneNum } from '../Appointment/Dealership/DealershipPhone';
import SelectedServices from '../Review/SelectedServices';
import UnsubmittedVehicleInfo from './UnsubmittedVehicleInfo';

const localizationConstants = require('../../shared/Constants/LocalizationConstants');

export const renderDealershipInfo = (props) => {
    const cityZipSpacing = props.dealershipSummary.address.postalZone ? ', ' : '';
    const subentityZipSpacing = props.dealershipSummary.address.countrySubentity ? ', ' : '';
    let postalZone = null;
    if (props.dealershipSummary.address.postalZone) {
        postalZone =
            props.vCountry === localizationConstants.US
                ? props.dealershipSummary.address.postalZone.slice(0, 5)
                : props.dealershipSummary.address.postalZone;
    }
    return (
        <div className="paper error-message-contact-dealer">
            <div className="headline3">{props.vTranslations.DEALER_INFO_HEADING}</div>
            <div className="dealership-info">
                <div className="dealership-name dealer-info-item">{props.dealershipSummary.name}</div>
                <div className="dealer-info-item">
                    {stringToTitleCase(props.dealershipSummary.address.addressLine1)}
                </div>
                <div className="dealer-info-item">
                    {stringToTitleCase(props.dealershipSummary.address.addressLine2)}
                </div>
                <div className="dealer-info-item">
                    {stringToTitleCase(props.dealershipSummary.address.cityName)}
                    {cityZipSpacing}
                    {props.dealershipSummary.address.countrySubentity}
                    {subentityZipSpacing}
                    {postalZone}
                </div>
                <div className="dealer-info-item">{`${getPhoneNum(props.dealershipSummary, props.vCountry)}`}</div>
            </div>
        </div>
    );
};
export const renderErrorDetails = (props) => {
    const errorSource = props.location.state?.errorSource || 'unknown';

    console.log(`Rendering error details for source: ${errorSource}`);

    // Base error message that appears in all cases
    const errorMessage = (
        <div className="error-message-try-again">
            {props.vTranslations.DMS_ERROR_CONTACT_DEALER
                ? props.vTranslations.DMS_ERROR_CONTACT_DEALER.replace(
                      '{{dealership}}',
                      props.dealershipSummary.name
                  ).replace('{{number}}', getPhoneNum(props.dealershipSummary, props.vCountry))
                : 'Please try again later or contact your dealer to schedule an appointment'}
        </div>
    );

    if (errorSource === 'appointment') {
        // For appointment errors, show dealership info, vehicle, and services
        return (
            <>
                {errorMessage}
                {renderDealershipInfo(props)}
                <div className="common-error-container">
                    <div className="review-unsubmitted-grid" style={{ display: 'grid', gap: '16px' }}>
                        <UnsubmittedVehicleInfo />
                        <SelectedServices />
                    </div>
                </div>
            </>
        );
    } else if (errorSource === 'legacyServices') {
        // For legacyServices errors, show dealership info and vehicle
        return (
            <>
                {errorMessage}
                {renderDealershipInfo(props)}
                <div className="common-error-container">
                    <div className="review-unsubmitted-grid" style={{ display: 'grid', gap: '16px' }}>
                        <UnsubmittedVehicleInfo />
                    </div>
                </div>
            </>
        );
    } else {
        // For all other errors, just show the error message
        if (props.dealershipSummary.name) {
            return errorMessage;
        }
    }
};
